import { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Grid,
  CardContent,
  CardMedia,
  IconButton,
  Autocomplete,
  Tooltip,
  Chip,
  Popover,
} from "@mui/material";
import { styled } from "@mui/system";
import Dropdown1 from "../../Dropdown/Dropdown1";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./RestaurantRegister.module.css";
import {
  useLoaderContext,
  useToastContext,
} from "../../../../Context/ToastContext";
import ClearIcon from "@mui/icons-material/Clear";
import LocationPicker from "../../LocationPicker/LocationPicker";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useUserContext } from "../../../../Context/UserContext";
import { Helmet } from "react-helmet";
import CloseIcon from "@mui/icons-material/Close";
import { apiGet, apiPost, apiPut } from "../../../../utils/ApiManager";

// Custom styled Paper for form sections
const SectionPaper = styled(Paper)({
  padding: "20px",
  marginBottom: "20px",
  // backgroundColor: "#f5f5f5",
});

const RestaurantRegister = ({ next, toUpdate }) => {
  const navigateTo = useNavigate();
  const { showToast } = useToastContext();
  const { setLoading } = useLoaderContext();
  const { restaurantID } = useParams();
  const [imageErrors, setImageErrors] = useState([]);
  const [selectedCuisine, setSelectedCuisine] = useState([]);
  const [cuisineList, setCuisineList] = useState([]);
  const [formData, setFormData] = useState({
    restaurantName: "",
    restaurantNumber: "",
    restaurantEmail: "",
    addressLine: "",
    country: "India",
    description: "",
    state: "",
    city: "",
    pincode: "",
    images: [],
    imageLinks: [],
    location: [],
    latitute: null,
    longitute: null,
    cuisineList: [],
    // mapLocation: "",
  });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areaTypes, setAreaTypes] = useState([]);
  const [errors, setErrors] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [imageIndexes, setImageIndexes] = useState([]);
  const [open, setOpen] = useState(false);
  const { requestConfirmation, getToken } = useUserContext();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const fetchRestaurantBasic =
    process.env.REACT_APP_FETCH_RESTAURANT_BASIC_DETAILS;
  const dropdownRestaurantReg =
    process.env.REACT_APP_FETCH_DROPDOWN_RESTAURANT_REGISTER;
  const fetchDropdownCountries = process.env.REACT_APP_FETCH_DROPDOWN_COUNTRIES;
  const fetchDropdownStates = process.env.REACT_APP_FETCH_DROPDOWN_STATES;
  const fetchDropdownCities = process.env.REACT_APP_FETCH_DROPDOWN_CITIES;
  const postRestaurantRegister = process.env.REACT_APP_POST_RESTAURANT_REGISTER;
  const handleUpdateBasicDetails =
    process.env.REACT_APP_PUT_HANDLE_UPDATE_RESTAURANT_BASIC_DETAILS;

  const handleSaveLocation = (location) => {
    setFormData({
      ...formData,
      longitute: location?.lng || null,
      latitute: location?.lat || null,
    });
  };

  const fetchRestaurantDetails = async () => {
    try {
      if (!restaurantID) return;
      setLoading(true);
      const response = await apiGet(`${fetchRestaurantBasic}/${restaurantID}`);
      if (response.success) {
        const restaurantData = response?.data;
        setFormData({
          restaurantName: restaurantData?.restaurantName || "",
          restaurantNumber: restaurantData?.restaurantNumber || "",
          restaurantEmail: restaurantData?.restaurantEmail || "",
          addressLine: restaurantData?.restaurantAddress?.addressLine || "",
          country: restaurantData?.restaurantAddress?.country || "",
          state: restaurantData?.restaurantAddress?.state || "",
          city: restaurantData?.restaurantAddress?.city || "",
          pincode: restaurantData?.restaurantAddress?.pincode || "",
          description: restaurantData?.description || "",
          images: restaurantData?.images || [],
          imageLinks: restaurantData?.images || [],
          cuisine: restaurantData?.cuisine || [],
          longitute: restaurantData?.location?.coordinates
            ? restaurantData?.location?.coordinates[0]
            : null,
          latitute: restaurantData?.location?.coordinates
            ? restaurantData?.location?.coordinates[1]
            : null,
          cuisineList: restaurantData.cuisineList || [],
        });
      } else {
        showToast(
          response?.message || "Failed to fetch data, try again later !",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong !",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveCuisine = (indexToRemove) => {
    const updated = [...selectedCuisine];
    updated.splice(indexToRemove, 1);
    setSelectedCuisine(updated);
  };

  const handleSelectTag = (event, newValue) => {
    setSelectedCuisine(newValue); // Update state when selection changes
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
  
    if (!file) return;
  
    const fileSizeInKB = file.size / 1024;
    const allowedFileTypes = ["image/jpeg", "image/jpg", "image/png"];
  
    if (fileSizeInKB > 300) {
      setImageErrors((prevErrors) => {
        const updatedErrors = [...prevErrors];
        updatedErrors[index] = "File size must be less than 300 KB.";
        return updatedErrors;
      });
      return;
    }
  
    if (!allowedFileTypes.includes(file.type)) {
      // showToast("Only image files (JPEG, PNG) are allowed.", "error");
      setImageErrors((prevErrors) => {
        const updatedErrors = [...prevErrors];
        updatedErrors[index] = "Only image files (JPEG, PNG) are allowed.";
        return updatedErrors;
      });
      return;
    }
  
    // Revoke old image URL if needed to prevent memory leaks
    if (formData.imageLinks[index]) {
      URL.revokeObjectURL(formData.imageLinks[index]);
    }
  
    const newImages = [...formData.images];
    newImages[index] = file;
  
    const newImageLinks = [...formData.imageLinks];
    newImageLinks[index] = URL.createObjectURL(file);
  
    if (restaurantID && !imageIndexes.includes(index)) {
      setImageIndexes((prev) => [...prev, index]);
    }
  
    setFormData((prevData) => ({
      ...prevData,
      images: newImages,
      imageLinks: newImageLinks,
    }));
  
    setImageErrors((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[index] = "";
      return updatedErrors;
    });
  };
  

  const handleRemoveImage = (index) => {
    setFormData((prev) => {
      const newImages = [...prev.images];
      const newImageLinks = [...prev.imageLinks];

      // Remove the specific image
      newImages.splice(index, 1);
      newImageLinks.splice(index, 1);

      return { ...prev, images: newImages, imageLinks: newImageLinks };
    });
  };

  const handleAddImageInput = () => {
    const validImages = formData.images?.filter(Boolean) || [];

    // Check if max limit already reached
    if (validImages.length >= 4) {
      setErrors((prev) => ({
        ...prev,
        images: "You can only upload a maximum of 4 images",
      }));
      return;
    }

    // Clear any previous image error if within limit
    setErrors((prev) => ({
      ...prev,
      images: "",
    }));

    // Add new input for another image
    setFormData((prevData) => ({
      ...prevData,
      images: [...prevData.images, null],
      imageLinks: [...prevData.imageLinks, null],
    }));
  };

  const fetchDropdown = async () => {
    try {
      setLoading(true);

      const response = await apiGet(dropdownRestaurantReg);
      if (response.success) {
        const areaTypes = response?.data?.areaType || [];
        const tagList = response?.data?.cuisineTypeList || [];

        setAreaTypes(areaTypes || []);
        setCuisineList(tagList || []);
      } else {
        showToast(
          response?.message || "Something went wrong try again later !",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await apiGet(fetchDropdownCountries);
      if (response?.success) {
        setCountries(response.data || []);
      } else {
        showToast(
          response?.message || "Something went wrong try again later !",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchDropdown();
    if (restaurantID) {
      fetchRestaurantDetails();
    }
  }, []);

  useEffect(() => {
    if (formData.country) {
      // Fetch states based on selected country
      const fetchStates = async () => {
        try {
          setLoading(true);

          const response = await apiGet(
            `${fetchDropdownStates}=${formData.country}`
          );
          if (response?.success) {
            setStates(response.data || []);
          } else {
            showToast(
              response?.message || "Something went wrong try again later !",
              "error"
            );
          }
        } catch (error) {
          showToast(
            error?.response?.message ||
              error?.message ||
              "Something went wrong!",
            "error"
          );
        } finally {
          setLoading(false);
        }
      };
      fetchStates();
    } else {
      setFormData({ ...formData, state: "", city: "" }); // Clear state and city when country is deselected
      setStates([]);
      setCities([]);
    }
  }, [formData.country]);

  useEffect(() => {
    if (formData.state) {
      // Fetch cities based on selected state
      const fetchCities = async () => {
        try {
          setLoading(true);

          const response = await apiGet(
            `${fetchDropdownCities}=${formData.state}&country=${formData.country}`
          );
          if (response?.success) {
            setCities(response.data || []);
          } else {
            showToast(
              response?.message || "Something went wrong try again later !",
              "error"
            );
          }
        } catch (error) {
          showToast(
            error?.response?.message ||
              error?.message ||
              "Something went wrong!",
            "error"
          );
        } finally {
          setLoading(false);
        }
      };
      fetchCities();
    } else {
      setFormData({ ...formData, city: "" });
      setCities([]);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {}; // Object to store errors
    let isValid = true; // Set isValid to true initially

    // Loop through each field in formData and check if it's empty
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "This field is required"; // Set the generic error message
        isValid = false; // Set isValid to false
      }
    });

    if (formData.restaurantName && formData.restaurantName.length > 60) {
      newErrors.restaurantName = "Name must be less than 60 characters";
      isValid = false;
    }

    // Address Line
    if (formData.addressLine && formData.addressLine.length > 60) {
      newErrors.addressLine = "Address must be less than 60 characters";
      isValid = false;
    }

    // Phone Number
    const phoneRegex = /^[0-9]{10}$/;
    if (
      formData.restaurantNumber &&
      !phoneRegex.test(formData.restaurantNumber)
    ) {
      newErrors.restaurantNumber = "Phone number must be exactly 10 digits";
      isValid = false;
    }

    // Email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (
      formData.restaurantEmail &&
      !emailRegex.test(formData.restaurantEmail)
    ) {
      newErrors.restaurantEmail = "Please enter a valid email address";
      isValid = false;
    }

    // Pincode
    if (
      formData.pincode &&
      (formData.pincode < 110000 || formData.pincode > 855999)
    ) {
      newErrors.pincode = "Pincode must be between 110000 and 855999";
      isValid = false;
    }

    // Description length
    if (formData.description && formData.description.length > 200) {
      newErrors.description = "Description must be less than 200 characters";
      isValid = false;
    }

    // Cuisine
    if (!selectedCuisine.length) {
      newErrors.cuisine = "Please select at least one cuisines.";
      isValid = false;
    } else if (selectedCuisine.length > 5) {
      newErrors.cuisine = "You can select up to 5 cuisines only.";
      isValid = false;
    }

    // Images validation
    const validImages = formData.images?.filter(Boolean) || [];
    if (validImages.length > 4) {
      newErrors.images = "You can only upload a maximum of 4 images";
      isValid = false;
    }

    if (!formData.latitute || !formData.longitute) {
      newErrors.location = "Please select a location";
      isValid = false;
    }

    // Set errors state

    setErrors(newErrors);
    setIsButtonDisabled(!isValid);

    return isValid; // Return the final validity status
  };

  useEffect(() => {
    const isValid = validateForm();
    setIsButtonDisabled(!isValid);
  }, [formData, selectedCuisine]);

  const handleRegister = async () => {
    try {
      setLoading(true);
      formData.cuisineList = selectedCuisine.map((cuisine) => cuisine.label);
      // Simple validation for required fields
      if (
        !formData.restaurantName ||
        !formData.restaurantNumber ||
        !formData.restaurantEmail
      ) {
        setErrors("Please fill in all required fields.");
        return;
      }

      // Clear error if validation passes
      setErrors("");

      const response = await apiPost(postRestaurantRegister, formData, true);

      if (response.success) {
        // setRestaurantID(response?.data?.data?.restaurantId || "")
        const data = response.data;
        navigateTo(`/restaurants/${data?.restaurantId}/details`);
        // Redirect or perform another action
      } else {
        showToast(
          response?.message || "Something went wrong try again later !",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    try {
      setLoading(true);
      formData.cuisineList = selectedCuisine.map((cuisine) => cuisine.label);
      formData["updateIndexes"] = imageIndexes;
      const response = await apiPut(
        `${handleUpdateBasicDetails}/${restaurantID}`,
        formData,
        true
      );
      if (response.success) {
        showToast(
          response?.message || "Restaurant details updated successfully.",
          "success"
        );
        const data = response.data;
        navigateTo(`/restaurants/${data?.restaurantId}/details`);
      } else {
        showToast(
          response?.message || "Something went wrong try again later !",
          "error"
        );
      }
    } catch (error) {
      showToast(
        error?.response?.message || error?.message || "Something went wrong!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // This will be called when the form is submitted
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await requestConfirmation(
      "Want to save these details and move ahead ?"
    );
    if (!result) return;

    if (!restaurantID) {
      await handleRegister();
    } else {
      await handleUpdate();
    }
  };

  useEffect(() => {
    if (cuisineList.length && formData.cuisineList?.length) {
      const selected = cuisineList.filter((option) =>
        formData.cuisineList.includes(option.label)
      );
      setSelectedCuisine(selected);
    }
  }, [cuisineList, formData.cuisineList]);

  useEffect(() => {}, [formData]);

  return (
    <Box className={styles.mainProfilePage}>
      <Helmet>
        <title>Register Restaurant | DiNEST</title>
        <meta name="description" content="Register restaurant on DiNEST" />
      </Helmet>
      <Box className={styles.mainContainer}>
        <Typography variant="h4" className={styles.containerTitle}>
          Restaurant Registration {!restaurantID ? "" : "(edit)"}
        </Typography>

        <form onSubmit={handleSubmit}>
          {/* Restaurant Details */}
          <SectionPaper className={styles.sectionColor}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
              Restaurant Details
            </Typography>

            <Grid container spacing={2}>
              <Grid className={styles.gridInput}>
                <TextField
                  label="Restaurant name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  name="restaurantName"
                  value={formData.restaurantName}
                  onChange={handleChange}
                  className={styles.inputTextfield}
                />
                {errors.restaurantName && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.restaurantName}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridInput}>
                <Autocomplete
                  multiple
                  options={cuisineList}
                  fullWidth
                  className={styles.gridDropdownInputbox}
                  getOptionLabel={(option) => option?.label}
                  value={selectedCuisine}
                  onChange={handleSelectTag}
                  filterSelectedOptions
                  disableClearable
                  renderTags={(value, getTagProps) => {
                    const visibleTags = value.slice(0, 2);
                    const extraCount = value.length - visibleTags.length;

                    return (
                      <div className={styles.chipWrapper}>
                        {visibleTags?.map((option, index) => (
                          <Tooltip
                            arrow
                            title={option.label}
                            key={option.label}
                          >
                            <Chip
                              label={option.label}
                              {...getTagProps({ index })}
                              onClick={() => {}}
                              style={{ cursor: "default" }}
                              className={styles.truncatedChip}
                            />
                          </Tooltip>
                        ))}
                        {extraCount > 0 && (
                          <Chip
                            label={`+${extraCount} more`}
                            onClick={(event) => {
                              event.stopPropagation();
                              setAnchorEl(event.currentTarget);
                              setPopoverOpen(true);
                            }}
                            className={styles.truncatedChip}
                          />
                        )}
                      </div>
                    );
                  }}
                  renderInput={(params) => (
                    <Tooltip
                      arrow
                      title={
                        selectedCuisine.length > 0
                          ? selectedCuisine.map((c) => c.label).join(", ")
                          : ""
                      }
                    >
                      <TextField {...params} label="Cuisine" />
                    </Tooltip>
                  )}
                />

                {errors.cuisine && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.cuisine}
                  </p>
                )}

                <Popover
                  open={popoverOpen}
                  anchorEl={anchorEl}
                  onClose={() => setPopoverOpen(false)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                  <Box sx={{ p: 2, maxWidth: 300 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Selected Cuisines
                    </Typography>
                    {selectedCuisine.map((cuisine, index) => (
                      <Chip
                        key={cuisine.label}
                        label={cuisine.label}
                        onDelete={() => handleRemoveCuisine(index)}
                        sx={{ m: 0.5 }}
                      />
                    ))}
                  </Box>
                </Popover>
              </Grid>
            </Grid>
          </SectionPaper>

          {/* Restaurant Contact Details */}
          <SectionPaper className={styles.sectionColor}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
              Restaurant Contact Details
            </Typography>

            <Grid container spacing={2}>
              <Grid className={styles.gridInput}>
                <TextField
                  label="Restaurant phone"
                  type="number"
                  fullWidth
                  variant="outlined"
                  name="restaurantNumber"
                  value={formData.restaurantNumber}
                  onChange={handleChange}
                  className={styles.inputTextfield}
                />
                {errors.restaurantNumber && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.restaurantNumber}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridInput}>
                <TextField
                  label="Restaurant email"
                  type="email"
                  fullWidth
                  variant="outlined"
                  name="restaurantEmail"
                  value={formData.restaurantEmail}
                  onChange={handleChange}
                  className={styles.inputTextfield}
                />
                {errors.restaurantEmail && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.restaurantEmail}
                  </p>
                )}
              </Grid>
            </Grid>
          </SectionPaper>

          <SectionPaper className={styles.sectionColor}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
              Restaurant Description
            </Typography>

            <Grid container spacing={2}>
              <Grid className={styles.descriptionInput}>
                <TextField
                  label="Restaurant description"
                  type="text"
                  fullWidth
                  variant="outlined"
                  name="description"
                  multiline
                  rows={3}
                  value={formData.description}
                  onChange={handleChange}
                  className={styles.descriptionInputBox}
                />
                {errors.description && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.description}
                  </p>
                )}
              </Grid>
            </Grid>
          </SectionPaper>

          {/* Address Information */}
          <SectionPaper className={styles.sectionColor}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
              Restaurant Address
            </Typography>

            <Grid container spacing={2}>
              <Grid className={styles.addressInput}>
                <TextField
                  label="Address line"
                  type="text"
                  fullWidth
                  variant="outlined"
                  name="addressLine"
                  value={formData.addressLine}
                  onChange={handleChange}
                  className={styles.inputTextfield}
                />
                {errors.addressLine && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.addressLine}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridPincode}>
                <TextField
                  label="Pincode"
                  type="number"
                  fullWidth
                  variant="outlined"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  className={styles.inputTextfield}
                />
                {errors.pincode && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.pincode}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridCountryDropdown}>
                <Dropdown1
                  label={"Country"}
                  name={"country"}
                  options={countries}
                  value={formData.country}
                  onChange={handleChange}
                />
                {errors.country && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.country}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridCountryDropdown}>
                <Dropdown1
                  label={"State"}
                  name={"state"}
                  options={states}
                  value={formData.state}
                  onChange={handleChange}
                />
                {errors.state && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.state}
                  </p>
                )}
              </Grid>

              <Grid className={styles.gridCountryDropdown}>
                <Dropdown1
                  label="City"
                  fullWidth
                  variant="outlined"
                  name="city"
                  value={formData.city}
                  options={cities}
                  onChange={handleChange}
                />
                {errors.city && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors.city}
                  </p>
                )}
              </Grid>

              <Grid className={styles.addressInput}>
                <Box className={styles.latituteContainer}>
                  <Typography>
                    Latitute : {formData?.latitute || "N/A"}
                  </Typography>
                  <Typography gutterBottom sx={{ mb: 2 }}>
                    Longitute : {formData?.longitute || "N/A"}
                  </Typography>
                </Box>
                <Button
                  className={styles.pickLocationButton}
                  variant="outlined"
                  onClick={() => setOpen(true)}
                >
                  Pick Location
                </Button>
                {errors?.location && (
                  <p className={styles.error} style={{ minHeight: "1.5rem" }}>
                    {errors?.location}
                  </p>
                )}
              </Grid>
            </Grid>
          </SectionPaper>

          <SectionPaper className={styles.sectionColor}>
            <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
              Upload Restaurant Images
            </Typography>

            <Grid container spacing={2} className={styles.inputBoxing}>
              {formData.images?.map((image, index) => (
                <Box key={index}>
                  <CardContent className={styles.inputContainer}>
                    <Box className={styles.closeIconWrapper}>
                      <CloseIcon
                        onClick={() => handleRemoveImage(index)}
                        className={styles.closeIcon}
                        fontSize="small"
                      />
                    </Box>
                    <Box>
                      <Typography
                        variant="body1"
                        className={styles.uploadRestTitle}
                      >
                        Upload image
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        (Image &lt; 300kb)
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      component="label"
                      className={styles.uploadButton}
                      startIcon={<CloudUploadIcon />}
                      onClick={() =>
                        document.getElementById(`image-upload-${index}`).click()
                      }
                    >
                      {image ? "Update" : "Upload"}
                    </Button>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      hidden
                      id={`image-upload-${index}`}
                      accept="image/*"
                      onChange={(e) => handleImageChange(e, index)}
                    />
                    {imageErrors[index] && (
                      <p className={styles.errorUpload}>{imageErrors[index]}</p>
                    )}

                    {/* Display filename of the selected image */}

                    {image?.name && (
                      <Box display="flex" justifyContent="center">
                        <Box display="flex" alignItems="center">
                          <Typography
                            variant="caption"
                            sx={{
                              display: "inline-block",
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              maxWidth: 120,
                              cursor: "pointer",
                            }}
                          >
                            {image.name}
                          </Typography>
                          <IconButton
                            onClick={() => handleRemoveImage(index)}
                            size="small"
                            sx={{ ml: 0.5 }}
                          >
                            <ClearIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        </Box>
                      </Box>
                    )}

                    {formData?.imageLinks[index] && (
                      <CardMedia
                        component="img"
                        height="150"
                        // width="150"
                        // style={styles.imageDisplay}
                        image={formData?.imageLinks[index]}
                      />
                    )}
                  </CardContent>
                </Box>
              ))}
            </Grid>
            {errors.images && (
              <Typography color="error" sx={{ mt: 1, textAlign: "center" }}>
                {errors.images}
              </Typography>
            )}

            <Button
              className={styles.addImageButton}
              onClick={handleAddImageInput}
              variant="outlined"
            >
              Add Image
            </Button>
          </SectionPaper>

          <Box className={styles.updateButton}>
            <Button
              className={styles.saveButton}
              sx={{ backgroundColor: "#207d46", color: "white" }}
              disabled={isButtonDisabled}
              variant="contained"
              type="submit"
            >
              Save & Next
            </Button>
          </Box>
        </form>
      </Box>
      <LocationPicker
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSaveLocation}
        latitute={formData.latitute}
        longitute={formData.longitute}
      />
    </Box>
  );
};

export default RestaurantRegister;
